import axios from 'axios';

export default {

    obtenerSujetoPorCodigo(p_email, p_usuario, p_codigo, p_tipo) {
        return axios
            .post('spoc/modppentry', {
                "p_email": p_email,
                "p_metodo": "modppbusqueda.buscapersona",
                "p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
                    "p_codigo": p_codigo,
                    "p_pais": null,
                    "p_tipo": p_tipo
                })
            })
    },

    obtenerSujetoPorIdNacion(p_email, p_usuario, p_idnacion, p_tipo) {
        return axios
            .post('spoc/modppentry', {
                "p_email": p_email,
                "p_metodo": "modppbusqueda.buscapersona",
                "p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
                    "p_idnacion": p_idnacion,
                    "p_pais": null,
                    "p_tipo": p_tipo
                })
            })
    },

    obtenerSujetoPorNombre(p_email, p_usuario, p_texto, p_tipo) {
        return axios
            .post('spoc/modppentry', {
                "p_email": p_email,
                "p_metodo": "modppbusqueda.buscapersona",
                "p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
                    "p_texto": p_texto,
                    "p_pais": null,
                    "p_max": 100,
                    "p_tipo": p_tipo
                })
            })
    },

    obtenerPepSujetoPorRut(p_rut) {
        return axios
            .get('pep/consultar?rut=' + p_rut, {})
    }
}
